/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PharmacyInfo } from "./PharmacyInfo";

export interface CarePlanMedication {
  name: string;
  patient_instructions: string;
  pharmacy?: PharmacyInfo | null;
}
